import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Document, Page, pdfjs } from 'react-pdf'

// Helpers
import Api from 'CoP/helpers/api'

// Components
import Header from 'CoP/components/layouts/Header'
import Footer from 'CoP/components/layouts/Footer'
import YouTubePlayer from 'CoP/components/app/YouTubePlayer'

// Set the worker source (add this near the top of your file, after imports)
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const COPDetail = () => {
    const { id } = useParams()
    const [copDetail, setCopDetail] = useState(null)
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const api = new Api()

    const fetchCOPDetail = () => {
        api.getCOPDetail(id)
            .then(response => {
                setCopDetail(response.data.data)
            })   
            .catch(error => {
                console.error(error)
            })
            .finally(() => {
            })
    }

    useEffect(() => {
        fetchCOPDetail()
    }, [id])

    // Breadcrumb component
    const Breadcrumb = ({ category, title }) => (
        <div className="container-fluid px-15 py-3">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0" style={{ backgroundColor: 'transparent', padding: 0 }}>
                    <li className="breadcrumb-item">
                        <Link to="/cop" className="text-muted text-hover-primary">
                            Beranda
                        </Link>
                    </li>
                    <li className="breadcrumb-item">
                        <i className="bi bi-chevron-right text-muted"></i>
                    </li>
                    <li className="breadcrumb-item">
                        <Link to={`/cop/category/${category}`} className="text-muted text-hover-primary">
                            {category}
                        </Link>
                    </li>
                    <li className="breadcrumb-item">
                        <i className="bi bi-chevron-right text-muted"></i>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        <span className='text-gray-800 fw-semibold'>
                            {title}
                        </span>
                    </li>
                </ol>
            </nav>
        </div>
    )

    return (
        <div className='container-fluid p-0 overflow-hidden' style={{ backgroundColor: '#FAF9F5' }}>
            <style>
                {`
                    .pdf-container {
                        width: 100%;
                        margin: 0;
                        border-top-left-radius: 8px;
                        border-top-right-radius: 8px;
                        overflow: hidden;
                    }
                    
                    @media (min-width: 768px) {
                        .pdf-container {
                            width: 50%;
                            margin: 0 auto;
                        }
                    }
                `}
            </style>
            <Header />
            
            <Breadcrumb 
                category={copDetail?.kategori?.nama_kategori} 
                title={copDetail?.judul}
            />

            <div className='px-15 py-5'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h1 className='display-5 fw-bold text-primary mb-4' style={{ textTransform: 'unset' }}>
                            {copDetail?.judul}
                        </h1>
                    </div>
                </div>
            </div>

            <div className='px-15 py-5'>
                <div className='row'>
                    {/* Main Article */}
                    <div className='col-md-8'>
                        <div className='card mb-5'>
                            {/* PDF Viewer using react-pdf */}
                            {copDetail?.upload_dokumen ? (
                                <div className="pdf-container">
                                    <Document
                                        file={copDetail.upload_dokumen}
                                        onLoadSuccess={onDocumentLoadSuccess}
                                        loading={<div className="text-center p-5">Loading PDF...</div>}
                                        error={<div className="text-center p-5 text-danger">Failed to load PDF</div>}
                                    >
                                        <Page 
                                            pageNumber={pageNumber} 
                                            width={window.innerWidth > 768 ? 600 : window.innerWidth - 60}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                        />
                                    </Document>
                                    
                                    {numPages && (
                                        <div className="d-flex justify-content-between align-items-center p-3 bg-light">
                                            <button 
                                                className="btn btn-sm btn-primary" 
                                                disabled={pageNumber <= 1} 
                                                onClick={() => setPageNumber(pageNumber - 1)}
                                            >
                                                <i className="bi bi-chevron-left"></i> Previous
                                            </button>
                                            
                                            <p className="mb-0">
                                                Page {pageNumber} of {numPages}
                                            </p>
                                            
                                            <button 
                                                className="btn btn-sm btn-primary" 
                                                disabled={pageNumber >= numPages} 
                                                onClick={() => setPageNumber(pageNumber + 1)}
                                            >
                                                Next <i className="bi bi-chevron-right"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <img
                                    src={copDetail?.upload_thumbnail}
                                    alt='Featured'
                                    className='card-img-top'
                                    style={{ maxHeight: 350, objectFit: 'cover', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}
                                />
                            )}
                            <div className='card-body'>
                                <div className='d-flex align-items-center justify-content-between border-bottom pb-3 mb-3'>
                                    {/* Meta Info */}
                                    <div className='d-flex align-items-center text-muted fs-5' style={{ fontSize: 14 }}>
                                        <div className='d-flex align-items-center gap-2'>
                                            <span className='text-gray-800 fw-bold'>{copDetail?.traffic_count || 0}</span>
                                            <span className=''>x dilihat</span>
                                            <span className=''>- dibuat pada</span>
                                            <span className='text-gray-800 fw-bold'>{copDetail?.created_at ? new Date(copDetail.created_at).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : ''}</span>
                                        </div>
                                    </div>
                                    {/* Share Buttons */}
                                    <div className=''>
                                        <span className='me-2 fs-5'>Bagikan:</span>
                                        <a 
                                            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="btn btn-light btn-sm me-1"
                                            onClick={() => {
                                                api.getCOPDetailShare(id);
                                            }}
                                        >
                                            <i className="bi bi-facebook"></i>
                                        </a>
                                        <a 
                                            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(copDetail?.judul || '')}`} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="btn btn-light btn-sm me-1"
                                            onClick={() => {
                                                api.getCOPDetailShare(id);
                                            }}
                                        >
                                            <i className="bi bi-twitter"></i>
                                        </a>
                                        <a 
                                            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="btn btn-light btn-sm me-1"
                                            onClick={() => {
                                                api.getCOPDetailShare(id);
                                            }}
                                        >
                                            <i className="bi bi-linkedin"></i>
                                        </a>
                                        <a 
                                            href="#" 
                                            className="btn btn-light btn-sm" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                api.getCOPDetailShare(id);
                                                navigator.clipboard.writeText(window.location.href);
                                                alert('Link berhasil disalin!');
                                            }}
                                        >
                                            <i className="bi bi-link-45deg"></i>
                                        </a>
                                    </div>
                                </div>
                                {/* Article Content */}
                                <div className='text-gray-800 fs-5' style={{lineHeight: 1.7}} dangerouslySetInnerHTML={{ __html: copDetail?.abstrak }} />

                                {copDetail?.link_youtube && (
                                    <div className='mt-5'>
                                        <YouTubePlayer key={copDetail?.link_youtube} videoId={copDetail?.link_youtube} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Sidebar */}
                    <div className='col-md-4'>
                        {copDetail?.related_articles && copDetail?.related_articles.length > 0 && (
                            <>
                                <h6 className='fw-bold text-gray-800 mb-5'>CoP Lainnya</h6>
                                {copDetail?.related_articles.map((article, index) => (
                                    <Link to={`/cop/${article.id}`} key={index}>
                                        <div className='card mb-5' key={index}>
                                            <div className='card-body'>
                                                <div className='d-flex align-items-center justify-content-between gap-3'>
                                                    <div className='d-flex align-items-center' style={{width: '35%'}}>
                                                        <img src={article.upload_thumbnail} alt={article.judul} className='' style={{ width: '100%', height: '94px', objectFit: 'contain', borderRadius: 8 }} />
                                                    </div>
                                                    <div className='d-flex flex-column justify-content-between w-100' style={{width: '65%', height: '84px'}}>
                                                        <div>
                                                            <h6 className='card-title mb-0 text-gray-800' style={{ textTransform: 'unset', fontSize: 16, lineClamp: 2, overflow: 'hidden', textOverflow: 'ellipsis' }}>{article.judul}</h6>
                                                        </div>
                                                        <div className='d-flex align-items-center gap-1'>
                                                            <span className='text-gray-800 fw-bold'>{article.traffic_count || 0}</span>
                                                            <span className='text-gray-800'>x dilihat</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default COPDetail